import { useId, useState } from "react";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip
} from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import SettingsBrightnessIcon from "@mui/icons-material/SettingsBrightness";
import { useThemeMode, type ThemePreference } from "../ThemeModeContext";

const choices = [
  { value: "system", label: "System", Icon: SettingsBrightnessIcon },
  { value: "light", label: "Light", Icon: LightModeIcon },
  { value: "dark", label: "Dark", Icon: DarkModeIcon }
] as const;

export function ThemeToggle() {
  const { preference, setPreference } = useThemeMode();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const id = useId();
  const selected = choices.find((choice) => choice.value === preference)!;
  function choose(value: ThemePreference) {
    setPreference(value);
    setAnchor(null);
  }
  return (
    <>
      <Tooltip title={`Theme: ${selected.label}`}>
        <IconButton
          id={`${id}-button`}
          aria-label={`Choose theme, current: ${selected.label}`}
          aria-haspopup="menu"
          aria-expanded={Boolean(anchor)}
          aria-controls={anchor ? id : undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ color: "text.secondary" }}
        >
          <selected.Icon />
        </IconButton>
      </Tooltip>
      <Menu
        id={id}
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ list: { "aria-labelledby": `${id}-button` } }}
      >
        {choices.map(({ value, label, Icon }) => (
          <MenuItem
            key={value}
            role="menuitemradio"
            aria-checked={preference === value}
            selected={preference === value}
            onClick={() => choose(value)}
          >
            <ListItemIcon>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
